import type { TenantThemeConfig } from "@/config/themes/types";
import { THEME_MODE } from "@/constants";

export const darkThemeConfig: TenantThemeConfig = {
  id: THEME_MODE.DARK,
  mode: THEME_MODE.DARK,
  colors: {
    primary: "#395C3C",
    primaryDark: "#2D4730",
    primaryLight: "#456F48",
    secondary: "#E1E9E2",
    accent: "#395C3C",
    error: "#E45353",
    success: "#2BA87B",
    warning: "#F3B949",
    info: "#4A8FE7",
    severityHigh: "#E45353",
    severityMedium: "#FB923C",
    severityLow: "#FACC15",
    background: "#0F1115",
    surface: "#181B21",
    surfaceAlt: "#1A1D23",
    surfaceRaised: "#23272F",
    border: "#2A2E36",
    sidebarBorder: "#F5F7FA24",
    textPrimary: "#F5F7FA",
    textSecondary: "#A4A9B3",
    textDisabled: "#6B707A",
    textOnPrimary: "#F5F7FA",
    gradientBackground:
      "linear-gradient(135deg, #395C3C 0%, #081515 15%, #081515 85%, #395C3C 100%)",
    hoverPrimary: "#456F48",
    hoverSecondary: "rgba(255, 255, 255, 0.08)",
    hoverTertiary: "rgba(255, 255, 255, 0.12)",
    surfaceHover: "rgba(255, 255, 255, 0.05)",
    chartPalette: ["#395C3C", "#4A8FE7", "#2BA87B", "#F3B949", "#456F48", "#34E0C8", "#E1E9E2"],
  },
  overlay: {
    light05: "rgba(255, 255, 255, 0.05)",
    light10: "rgba(255, 255, 255, 0.10)",
    light20: "rgba(255, 255, 255, 0.20)",
    olive15: "rgba(57, 92, 60, 0.15)",
  },
  typography: {
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
  },
};
